
export function cargarJsonSga(state, jsonSga) {

    state.jsonSga = jsonSga.codigos;

}

export function setSga(state, sga){
    state.selectedSgaEt.codigos = sga.codigosh;
}

/**
 * Mutación que carga la informacion de los pictogramas sga del producto químico.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} pictogramas contiene la información de los pictogramas sga del producto químico.
 */
export function setSgaPictogramas(state, pictogramas) {
    //http://127.0.0.1:8000/img/sga/pictogramas/
    state.pictogramas_et = {Homologacion:[],Clasificacion:[]};

    pictogramas.Homologacion.forEach(pictograma => {
        if( pictograma.estado == 0 ) {
            //Asigna clase sin estado
            pictograma.clase = 'pictograma';
        } else {
            //Asigna clase con estado
            pictograma.clase = 'seleccionado';
        }
    });

    state.pictogramas_et = pictogramas;
}


/**
 * Mutación que carga la informacion de las frases sga del producto químico.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} frases contiene la información de las frases sga del producto químico.
 */
export function setSgaFrases(state, frases) {
    state.FrasesEt = frases;

    state.Medidas.medidah4x6 = state.FrasesEt.medidas[0][0];
    state.Medidas.medidap4x6 = state.FrasesEt.medidas[0][1];
    state.Medidas.medidah7x10 = state.FrasesEt.medidas[1][0];
    state.Medidas.medidap7x10 = state.FrasesEt.medidas[1][1];
    state.Medidas.medidah18x10 = state.FrasesEt.medidas[2][0];
    state.Medidas.medidap18x10 = state.FrasesEt.medidas[2][1];
    state.Medidas.medidah21x18 = state.FrasesEt.medidas[3][0];
    state.Medidas.medidap21x18 = state.FrasesEt.medidas[3][1];

}

/**
 * Mutación que carga la información del idioma.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} idioma contiene la información del idioma.
 */
export function cambiarIdioma (state, idioma) {
    state.idioma = idioma;
}

/**
 * Mutación que carga la información de la versión de SGA.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} version contiene la información de las versiones SGA.
 */
export function cambiarVersion (state, version) {
    state.version = version;
}

/**
 * Mutación que cambia el tipo de frases SGA.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} tipo contiene la información de los tipos de frases.
 */
export function cambiarTipo (state, tipo) {
    state.tipo = tipo;
}

/**
 * Mutación para limpiar los campos pertenecientes a empresa.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function limpiarEmpresa (state) {
    state.filtro.empresa = "";
}

/**
 * Mutación para cambiar la empresa en SGA.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} empresa contiene la información de las empresas.
 */
export function cambiarEmpresa (state, empresa) {
    state.filtro.empresa = empresa;
}

/**
 * Mutación para cambiar la empresa en SGA.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} empresa contiene la información de las empresas.
 */
export function setCategorias(state, categorias) {
    state.categorias = [];
    if( categorias.listado.length > 0){
        state.categorias = categorias.listado;
        state.codigosRepetidos = categorias.codigosRepetidos;
    }
}



